// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1yxKs","inputWrap":"CustomTip_inputWrap__35mTn"};